import React from 'react';
import './CampaignNotStarted.css';

const CampaignNotStarted: React.FC = () => {
  return (
    <div className="campaign-not-started">
      <div className="campaign-not-started__content">
        <div className="campaign-not-started__icon">⏰</div>
        <h1 className="campaign-not-started__title">Акция еще не началась</h1>
        <p className="campaign-not-started__message">
          Акция еще не активна. 
          Пожалуйста, подождите начала акции.
        </p>
        <div className="campaign-not-started__footer">
          <p>Следите за обновлениями!</p>
        </div>
      </div>
    </div>
  );
};

export default CampaignNotStarted;
